import React from 'react';

import FormData from './PotentialRisk';
import VerifyModal from './components/modals/VerifyModal';
import './PotentialRisk.scss';

const ShowPotentialRisk = ({
                            defaultData,
                            isModalVerifyOpen,
                            setIsModalVerifyOpen,
                          }) => {

  return (
    <div style={{width: "100%"}}>
      <FormData defaultData={defaultData} />
      <VerifyModal
        open={isModalVerifyOpen}
        id={defaultData?.id}
        isOpen={(e) => setIsModalVerifyOpen(e)}
      />
    </div>
  );
};

export default ShowPotentialRisk;